import { inject } from "vue";

import type { AppBreadcrumbItem } from "@tmi/types/context/search-context";

import type { LabelService } from "@/composables/label-service";
import { labelServiceSymbol } from "@/plugins/LabelServicePlugin";
import routeManager from "@/router/route-manager";

export function useAppBreadcrumbs() {
  const labelService = inject< LabelService >( labelServiceSymbol ) as LabelService;

  function dash(): AppBreadcrumbItem {
    return { label: labelService.label( 'lblDashboard' ), to: routeManager.homePath() };
  }

  function trail( ...segments: AppBreadcrumbItem[] ): AppBreadcrumbItem[] {
    return [ dash(), ...segments ];
  }

  return { labelService, dash, trail };
}
